import { CompaniesHouseOfficer } from '@finxone-platform/shared/sys-config-types';

export const MOCK_COMPANIES_HOUSE_OFFICERS: CompaniesHouseOfficer[] = [
  {
    isPrimary: true,
    name: 'SMITH, John',
    firstName: 'John',
    lastName: 'SMITH',
    email: 'anne.miller@acme.com',
    phoneNumber: '+447826341084',
    dob: '1970-02-11T18:30:00.000Z',
    officerRole: 'director',
    appointedOn: '2020-09-13',
    nationality: 'GB',
    occupation: 'Director',
    dateOfBirth: { month: 1, year: 1980 },
    address: {
      careOf: '',
      address1: '20-22 Wenlock Road',
      address2: '',
      country: 'GB',
      locality: 'London',
      postalCode: 'N1 7GU',
      poBox: '',
      premises: '',
      region: '',
    },
  },
  {
    name: 'DOE, Jane',
    officerRole: 'secretary',
    appointedOn: '2020-09-13',
    nationality: 'GB',
    occupation: 'Company Secretary',
    dateOfBirth: { month: 6, year: 1985 },
    address: {
      careOf: '',
      address1: '20-22 Wenlock Road',
      address2: '',
      country: 'GB',
      locality: 'London',
      postalCode: 'N1 7GU',
      poBox: '',
      premises: '',
      region: '',
    },
  },
  {
    name: 'BULL, Stone',
    officerRole: 'director',
    appointedOn: '2021-04-02',
    nationality: 'American',
    occupation: 'Managing Director',
    dateOfBirth: { month: 11, year: 1975 },
    address: {
      careOf: '',
      address1: 'Waterside Drive',
      address2: '',
      country: 'US',
      locality: 'Norfolk',
      postalCode: '23510',
      poBox: '',
      premises: '999',
      region: '',
    },
  },
  {
    name: 'BROWN, Charlie',
    officerRole: 'director',
    appointedOn: '2019-02-11',
    resignedOn: '2022-08-30',
    nationality: 'GB',
    occupation: 'Director',
    dateOfBirth: { month: 9, year: 1970 },
    address: {
      careOf: '',
      address1: '20-22 Wenlock Road',
      address2: '',
      country: 'GB',
      locality: 'London',
      postalCode: 'N1 7GU',
      poBox: '',
      premises: '',
      region: '',
    },
  },
];
